// Libs
import classNames from 'classnames/bind';
import { Box, Grid2, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { useState } from 'react';
// Components, Layouts, Pages
// Others
import { StorageEnum } from '~/utils/enum/base';
import { RoleEnum } from '~/utils/enum/common';
import { adminRouteAbsolute } from '~/utils/routes/roleRoutes/admin';
import { salesAdminRouteAbsolute } from '~/utils/routes/roleRoutes/salesAdmin';
import { salesPersonRouteAbsolute } from '~/utils/routes/roleRoutes/salesPerson';
import { operationsManagerRouteAbsolute } from '~/utils/routes/roleRoutes/operationsManager';
import { warehouseLeadRouteAbsolute } from '~/utils/routes/roleRoutes/warehouseLead';
import { warehouseStaffRouteAbsolute } from '~/utils/routes/roleRoutes/warehouseStaff';
import { foremanRouteAbsolute } from '~/utils/routes/roleRoutes/foreman';
import { loaderRouteAbsolute } from '~/utils/routes/roleRoutes/loader';
import { crewRouteAbsolute } from '~/utils/routes/roleRoutes/crew';
// Styles, images, icons
import styles from './Auth.module.scss';

type AuthProps = {};

const cx = classNames.bind(styles);

const Auth = (props: AuthProps) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation(['common/auth']);
  const navigate = useNavigate();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  let currentRole: RoleEnum | null = null;

  try {
    const roleStr = localStorage.getItem(StorageEnum.ROLE);
    currentRole = roleStr ? JSON.parse(roleStr)?.[0] ?? null : null;
  } catch (e) {
    console.error('Invalid ROLE in localStorage', e);
  }
  const [accessToken] = useState<string | null>(localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null);
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleNavigateByRole = () => {
    switch (currentRole) {
      case RoleEnum.SUPER_ADMIN:
        navigate(adminRouteAbsolute.dashboard);
        break;
      case RoleEnum.SALES_ADMIN:
        navigate(salesAdminRouteAbsolute.dashboard);
        break;
      case RoleEnum.SALES_PERSON:
        navigate(salesPersonRouteAbsolute.dashboard);
        break;
      case RoleEnum.OPERATIONS_MANAGER:
        navigate(operationsManagerRouteAbsolute.dashboard);
        break;
      case RoleEnum.WAREHOUSE_LEAD:
        navigate(warehouseLeadRouteAbsolute.dashboard);
        break;
      case RoleEnum.WAREHOUSE_STAFF:
        navigate(warehouseStaffRouteAbsolute.dashboard);
        break;
      case RoleEnum.FOREMAN:
        navigate(foremanRouteAbsolute.dashboard);
        break;
      case RoleEnum.CREW:
        navigate(crewRouteAbsolute.dashboard);
        break;
      case RoleEnum.LOADER:
        navigate(loaderRouteAbsolute.dashboard);
        break;
    }
  };
  //#endregion Handle Function

  return accessToken && currentRole ? (
    <>{handleNavigateByRole()}</>
  ) : (
    <Grid2 id='authLayout' container className={cx('container')}>
      {matches && (
        <Grid2 size={{ lg: 4, xl: 3.5 }}>
          <Box className={cx('authBackgroundImage')} />
        </Grid2>
      )}

      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8.5 }}>
        <Box className={cx('authContent')}>
          <Outlet />
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default Auth;
